import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface CreateTicketInput {
  subject: string;
  description: string;
  categoryId?: string;
}

interface CreatedTicket {
  ticketId: string;
  subject: string;
  description: string;
  status: string;
  categoryId: string | null;
  createdAt: string;
}

interface UseCreateTicketReturn {
  createTicket: (input: CreateTicketInput) => Promise<CreatedTicket>;
  loading: boolean;
  error: string | null;
}

export function useCreateTicket(): UseCreateTicketReturn {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (input: CreateTicketInput) => api.createSupportTicket(input),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.customerSupport.tickets(),
      });
    },
  });

  return {
    createTicket: async (input: CreateTicketInput): Promise<CreatedTicket> => {
      return mutation.mutateAsync(input);
    },
    loading: mutation.isPending,
    error: mutation.error ? mutation.error.message : null,
  };
}
